import { ThemeCanvas } from "@sylviq/ui-react-web/components/ui/ThemeCanvas";
import { RouterProvider } from "@tanstack/react-router";
import { AppCategoryProvider } from "@/lib/app-category";
import { DevModeBanner } from "@/features/dev/DevModeBanner";
import { SessionProvider } from "@/lib/session";
import { router } from "@/routes/router";

export function App() {
  return (
    <ThemeCanvas appearance="glass">
      <DevModeBanner />
      <SessionProvider>
        <AppCategoryProvider>
          <RouterProvider router={router} />
        </AppCategoryProvider>
      </SessionProvider>
    </ThemeCanvas>
  );
}
